import { createSliceHookFactories } from '@tdp/common/form'

import { appDetailsSlice } from './slice';

export const {
  createZoomHook: createAppZoomHook,
  createEditsHook: createAppEditsHook,
  createStringInputPropsHook: createAppInputPropsHook,
  createRevertHook: createAppRevertHook,
} = createSliceHookFactories(appDetailsSlice);
